import keymaster from 'keymaster';
import _ from 'lodash';

const _stack = [];

function pushScope(scope) {
  _stack.push(scope);
  keymaster.setScope(scope);
}

function popScope() {
  _stack.pop();
  keymaster.setScope(_.last(_stack));
}

export default {
  keymaster,
  pushScope,
  popScope,
};
